import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Bot } from 'lucide-react';
import adminAssistantService from '../../services/adminAssistantService';
import AssistantPanel from './AssistantPanel';

/** Header button for the gift assistant. Hidden unless the backend says this admin may use it. */
const AssistantLauncher = () => {
  const [enabled, setEnabled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    adminAssistantService
      .getStatus()
      .then((status) => !cancelled && setEnabled(status?.enabled === true))
      .catch(() => {}); // any failure: stay hidden, no toast
    return () => {
      cancelled = true;
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Open assistant"
        title="Assistant"
        className="p-2.5 md:p-1.5 rounded-lg border border-border text-muted-foreground hover:bg-accent transition-colors"
      >
        <Bot size={16} />
      </button>
      {/* Portaled: the header is sticky z-10, a stacking context that would trap the fixed z-50 panel. */}
      {open && createPortal(<AssistantPanel onClose={() => setOpen(false)} />, document.body)}
    </>
  );
};

export default AssistantLauncher;
